import { $color, $cssVar } from "@/utils/cssVarUtils"
import { numberInputAnatomy as parts } from "@chakra-ui/anatomy"
import type {
  PartsStyleFunction,
  PartsStyleObject,
  SystemStyleFunction,
  SystemStyleObject,
} from "@chakra-ui/theme-tools"
import { Input } from "./input"


const baseStyleRoot: SystemStyleObject = {

}

const baseStyleField: SystemStyleObject = Input.baseStyle?.field ?? {}

const baseStyleStepperGroup: SystemStyleObject = {

}

const baseStyleStepper: SystemStyleFunction = (props) => {
  return {
    borderStart: "1px solid",
    borderStartColor: $color('bg-input-normal'),
    color: $color('text-normal'),
    _active: {
      bg: '',
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
    },
    _last: {
      borderColor: $color('bg-input-normal'),
    }
  }
}

const baseStyle: PartsStyleFunction<typeof parts> = (props) => ({
  root: baseStyleRoot,
  field: baseStyleField,
  stepperGroup: baseStyleStepperGroup,
  stepper: baseStyleStepper(props),
})

function getSize(size: string): PartsStyleObject<typeof parts> {
  const sizeStyle = Input.sizes[size]

  const fontSizeMap: Record<string, string> = {
    'sm': '2xs',
    'md': '2xs',
    'lg': '2xs',
  }
  const fontSize = fontSizeMap[size]

  return {
    field: {
      ...sizeStyle.field,
      verticalAlign: "top",
    },
    stepper: {
      fontSize,
      _first: {

      },
      _last: {
        mt: "-1px",
        borderTopWidth: 1,
      },
    },

  }
}

const sizes = {
  sm: getSize("sm"),
  md: getSize("md"),
  lg: getSize("lg"),
}

const variantFlushed: PartsStyleFunction<typeof parts> = (props) => {
  return {
    ...Input.variants.flushed(props),
    stepper: {
      _first: {
        border: 'none',
      },
      _last: {
        border: 'none',
      }
    }
  }
}

const variants = {
  ...Input.variants,
  flushed: variantFlushed,
}

const defaultProps = {
  ...Input.defaultProps,
}

export const NumberInput = {
  parts: parts.keys,
  baseStyle,
  sizes,
  variants,
  defaultProps,
}